import React from 'react';
import PropTypes from 'prop-types';
import ReactSelect from 'react-select';
import CreatableSelect from 'react-select/creatable';

// Custom styles for multi-value pills to match design
const multiValueStyles = {
  multiValue: base => ({
    ...base,
    backgroundColor: 'var(--bz-blue-1)',
    borderRadius: '50px',
    padding: '2px 4px 2px 10px',
    margin: '4px',
    minHeight: '32px',
    display: 'flex',
    alignItems: 'center'
  }),
  multiValueLabel: base => ({
    ...base,
    padding: '4px 4px 4px 0',
    fontSize: '0.875rem',
    color: 'var(--ink-invert)'
  }),
  multiValueRemove: base => ({
    ...base,
    borderRadius: '50%',
    padding: '2px 6px',
    cursor: 'pointer',
    color: 'var(--ink-invert)',
    ':hover': {
      backgroundColor: 'var(--btn-primary-hover)',
      color: 'var(--ink-invert)'
    }
  })
};

const Select = ({ isCreatable, styles, ...rest }) => {
  // Merge custom multi-value styles with any passed styles
  const mergedStyles = {
    ...multiValueStyles,
    ...styles,
    // Ensure multi-value styles are preserved even if styles prop is passed
    multiValue: base => ({
      ...multiValueStyles.multiValue(base),
      ...(styles?.multiValue ? styles.multiValue(base) : {})
    }),
    multiValueLabel: base => ({
      ...multiValueStyles.multiValueLabel(base),
      ...(styles?.multiValueLabel ? styles.multiValueLabel(base) : {})
    }),
    multiValueRemove: base => ({
      ...multiValueStyles.multiValueRemove(base),
      ...(styles?.multiValueRemove ? styles.multiValueRemove(base) : {})
    }),
    // Portal the menu to body so it's never clipped by overflow containers (accordions, modals, etc.)
    menuPortal: base => ({
      ...base,
      zIndex: 9999,
      ...(styles?.menuPortal ? styles.menuPortal(base) : {})
    })
  };

  // Default to portaling the menu to document.body to prevent clipping
  const portalProps = {
    menuPortalTarget: document.body,
    menuPosition: 'fixed'
  };

  if (isCreatable) {
    return <CreatableSelect {...portalProps} styles={mergedStyles} {...rest} />;
  }
  return <ReactSelect {...portalProps} styles={mergedStyles} {...rest} />;
};

Select.propTypes = {
  classNamePrefix: PropTypes.string,
  isCreatable: PropTypes.bool,
  styles: PropTypes.object
};

export default Select;
